import { render, staticRenderFns } from "./xeGridTableSetting.vue?vue&type=template&id=1771d5dd"
import script from "./xeGridTableSetting.vue?vue&type=script&lang=js"
export * from "./xeGridTableSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports